import { render, staticRenderFns } from "./PaperHead.vue?vue&type=template&id=4fd97269&scoped=true"
import script from "./PaperHead.ts?vue&type=script&lang=ts&external"
export * from "./PaperHead.ts?vue&type=script&lang=ts&external"
import style0 from "./PaperHead.vue?vue&type=style&index=0&id=4fd97269&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd97269",
  null
  
)

export default component.exports